

/**
 * The integer inside a port id, for the seams that must speak in bare ids - the file writers and
 * the generators that derive port ids from a component's.
 */
export function pToInt(_arg) {
    return _arg;
}

/**
 * The integer inside a component id. For the seams that must speak in bare ids - the file
 * writers, the SimpleDesign wire format, and the parameter types, which compile before this file
 * and so cannot name the type - and nowhere else: in between, the type is the point.
 */
export function cToInt(_arg) {
    return _arg;
}

/**
 * The integer inside a connection id, for the seams that must speak in bare ids - the file
 * writers, and the sorts that need a total order over wires.
 */
export function connToInt(_arg) {
    return _arg;
}

export function fcToInt(_arg) {
    return _arg;
}

export function dToInt(_arg) {
    return _arg;
}

